import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dot, LoadingContainer } from './styles';
export const LoadingDots = () => {
    return (_jsxs(LoadingContainer, { children: [_jsx(Dot, {}), _jsx(Dot, {}), _jsx(Dot, {})] }));
};
export default LoadingDots;
